import { Pipe, PipeTransform } from '@angular/core';
import { TruncatePipe } from './truncate.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { Post } from '../../channels/models/post.interface';

@Pipe({
  name: 'asPost'
})
export class AsPostPipe implements PipeTransform {

  transform(value: any): Post {
    if (!value || !value.contentType) {
      return value;
    }
    switch (value.contentType) {
      case 'posts':

        const truncatePipe = new TruncatePipe();
        const stripHtmlPipe = new StripHtmlPipe();

        return {

          Id: value.Id,
          image: value.ImagePath,
          Title: value.Title,
          channelTitle: value.channelTitle,
          CreatedOn: value.PublishDate,
          Author: {
            Id: '',
            EmployeeId: value.employeeId,
            Name: value.employeeName,
            ImageUrl: value.employeeImg
          },
          Files: [value.ImagePath].map(a => ({ Url: value.ImagePath, Caption: '', Extension: '', Name: '', Id: 0, UploadedOn: null })),
          UpdatedOn: '',
          contentType: value.contentType,
          Comments: [],
          Text: value.Text
        };
      default:
        return value;
        break;
    }
  }
}
